import React from 'react';
import { clsx } from 'clsx';
import Image from '@/src/shared/components/Image';

type Props = {
  className?: string;
  narrow?: boolean;
  direction: 'up' | 'down';
};

export function Quote({ className, direction, narrow }: Props) {
  return (
    <div
      className={clsx({
        [className]: className,
      })}
    >
      <Image
        src={`/images/rechard-silver-testimonial/quote-${direction}${
          narrow ? '-narrow' : ''
        }.svg`}
        width={narrow ? 54 : 91}
        height={narrow ? 44 : 64}
        objectFit="cover"
        alt=""
      />
    </div>
  );
}
